import React from 'react';

/** Catches render errors in marketing sections so one bad preview does not white-screen the page. */
class MarketingErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error, info) {
        console.error('[MarketingAssets]', error, info);
    }

    render() {
        const { error } = this.state;
        if (error) {
            return (
                <div
                    style={{
                        padding: 24,
                        background: '#fff5f5',
                        border: '1px solid #f5c2c2',
                        color: '#7f1d1d',
                        fontFamily: 'sans-serif',
                    }}
                >
                    <strong>Preview failed to render.</strong>
                    <pre style={{ marginTop: 12, whiteSpace: 'pre-wrap' }}>
                        {error.message}
                    </pre>
                </div>
            );
        }
        return this.props.children;
    }
}

export default MarketingErrorBoundary;
